import React from 'react';
import { RadioGroup } from '../design-system';

interface RadioGroupFieldProps {
  label?: string;
  [key: string]: any;
}

const RadioGroupField = ({ label, ...props }: RadioGroupFieldProps) => {
  return (
    <>
      {label && <p>{label}</p>}

      <RadioGroup {...props} label={null} />
    </>
  );
};

export default RadioGroupField;
